module.exports = __webpack_public_path__ + "img/promotions.43b12cd5.svg";